import React, {useEffect, useState} from "react";
import Link from 'next/link';
import Router from 'next/router';
import { orderState } from '../../atoms/store';
import { useRecoilState } from "recoil";

import InitializePage from '../../lib/server/page';
import Header from "../../components/Layouts/Header";
import HomeFooter from '../../components/Layouts/HomeFooter.jsx';
import Step1 from "../../components/Checkout/step1";
import CartNavigation from '../../components/common/cartnavigation.jsx';
import SubscribeNewsLetter from '../../components/common/subscribenewsletter.jsx';
import withAuthHOC from '../../lib/withAuthHOC';

import { updateProductQty, removeProductQty, saveForLaterProduct, getsaveForLaterProduct, convertprodtocart, checkifsplitOrder, checkcouponvalidity, deleteCoupon } from '../../lib/api/cart.jsx';
import { notifyMe } from "../../helper";
import { getCartUUID } from "../../lib/utils/cart";


const Checkout = ({user, menu, webTexts}) => {
    const [orders, setOrders] = useRecoilState(orderState);
    const [loader, setloader] = useState(false);
    const [couponvisible, setcouponvisible] = useState(false);
    const [productadded, setproductadded] = useState([]);
    const [displayStep, setdisplayStep] = useState('');
    const [isSplittable, setisSplittable] = useState('');
    const [couponval, setcouponval] = useState();
    const [couponvalid, setcouponvalid] = useState();
    const [screensresolution, setscreensResolution] = useState('default');
    const authenticationState  = !!user;

    useEffect(() => {
        if(user) {
            getlaterProducts();
        }
    }, [user])

    const updatecartquantity = async (productId, type, quantity) => {
        setloader(true);
        let obj, qty;
        if(Number(quantity) < Number(0)) {
            notifyMe({ key: 'cart', method: 'error', message: 'Please remove the product from cart'});
            return;
        }
        if(type == 'subtract') {
            qty = Number(quantity) - Number(1);
        } else {
            qty = Number(quantity) + Number(1);
        }
        obj = {
            "cartUuid": getCartUUID(),
            "productId": productId,
            "qty": qty
        }
        let response = await updateProductQty(obj);
        if(response.success === true) {
            setOrders(response.data);
        }
        setTimeout(() => { setloader(false); }, 2000);

    }

    const removeProduct = async (productId) => {
        let obj = {
            "cartUuid": getCartUUID(),
            "productId": productId
        }
        let response = await removeProductQty(obj)
        if(response.success) {
            setOrders(response.data);
        }
    }

    const  redirectToCartStep = () => {     
          
        const canBeShipped =  parseFloat(orders?.order?.grandTotal) >= parseFloat(12.00) ;
        const haveShippingData = orders?.order?.shippingMethod?.shippingAddres != null && orders?.order?.shippingMethod?.shippingAddres?.courier != null ;
        const isStoreDeliverySelected = orders?.order?.shippingMethod?.shopPickUpDetails != null;
        const haveBillingData = orders?.order?.billingAddress!= null;
        const havePaymentData = orders?.order?.payment?.paymentMethodID != null;
        const haveSurname = orders?.order?.customer?.surname != "";

        if(!authenticationState) {
            Router.push("/checkout/step2");
            return;
        } else {
            /*feature flag*/
            if(!haveSurname){
                Router.push('/checkout/myDataStep');
                return;
            }
            if(((haveShippingData && canBeShipped) || isStoreDeliverySelected) && havePaymentData && haveBillingData) {
                Router.push('/checkout/step5');
                return;
            } else if((haveShippingData && canBeShipped || isStoreDeliverySelected) && havePaymentData && !haveBillingData) {
                Router.push("/checkout/step4");
                return;
            } else {
                Router.push("/checkout/step3");
                return;
            }
        }
    }

    const getlaterProducts = async () => {
        let resp = await getsaveForLaterProduct();
        if(resp.success === true) {
        setproductadded(resp.data);
        return false;
        } else {
        setproductadded([]);
        }
    }

    const savelaterproduct = async (productId, action) => {
        let obj = {
        "productId": productId,
        "isRemoved": action
        }
        let resp = await saveForLaterProduct(obj);

        if(resp.success === true) {
        if(action == 0) {
            notifyMe({ key: 'myspace', method: 'success', message: 'Product added' });
            setOrders(resp?.data);
        } else {
            notifyMe({ key: 'myspace', method: 'success', message: 'Product removed' });
        }
        getlaterProducts();
        return false;
        } else {
        notifyMe({ key: 'myspace', method: 'error', message: resp.responseMessage });
        getlaterProducts();
        setOrders(resp?.data);
        return false;
        }
    }

    const addprodtocart = async(prodId) => {
        let response = await convertprodtocart(prodId)
        if(response.success === true) {
        notifyMe({ key: 'myspace', method: 'success', message: 'Product added' });
        setOrders(response?.data);
        getlaterProducts();
        return false;
        } else {
        notifyMe({ key: 'myspace', method: 'error', message: resp.responseMessage });
        setOrders(response?.data);
        getlaterProducts();
        return false;
        }
    }

    const checkifproductsplitable = async(issplitable) => {
        const resp = {
            "cartUuid": getCartUUID(),
            "splitTheOrder": issplitable
        };
        const response = await checkifsplitOrder(resp);

        if(response.success === true && (response?.data?.order?.isSplittable == 1)){
            notifyMe({ key: 'myspace', method: 'success', message: 'Vale, podemos separar los pedidos' });
            setOrders(response?.data);
            setisSplittable(1);
        } else {
            if (issplitable==1){
                notifyMe({ key: 'myspace', method: 'error', message: 'Lo sentimos, no podemos separar los pedidos, alguno no llegaría al mínimo de 12€' });
            }else{
                notifyMe({ key: 'myspace', method: 'success', message: 'Ok!, enviaremos todos los productos en un solo pedido' });
                setOrders(response?.data);
            }
            
            setisSplittable(0);
        }
    }

    const addCoupon = async () => {
        try {
        let resolution = window.innerWidth;
        let obj = {
            "cartUUID": getCartUUID(),
            "couponCode": couponval
        };
        let response = await checkcouponvalidity(obj);
        if(response?.responseCode === 127) {
            setcouponvalid(false);
            setcouponvisible(false);
            setcouponval('');
            if(resolution <= 1140 && resolution > 767)
            {
            setscreensResolution('tab');
            }
            return false;
        } else if (response?.responseCode === 128) {
            setcouponvisible(false);
            setcouponvalid(false);
            setcouponval('');
            if(resolution <= 1140 && resolution > 767)
            {
            setscreensResolution('tab');
            }
            return false;
        } else if (response?.responseCode === 130) {
            setcouponvisible(false);
            setcouponvalid(false);
            setcouponval('');
            if(resolution <= 1140 && resolution > 767)
            {
            setscreensResolution('tab');
            }
            return false;
        } else if (response.success === true) {
            setcouponvisible(true);
            setcouponvalid(true);
            setOrders(response?.data);
            return false;
        } else {
            setcouponvisible(false);
            return false;
        }
        } catch (err) {
        setcouponvisible(false);
        return false;
        }
    }

    const removeCoupon = async () => {
        try {
        let obj = {
            "cartUUID": getCartUUID(),
            "couponCode": couponval
        };
        let response = await deleteCoupon(obj);
        if(response?.success === true) {
            setcouponvisible(false);
            setcouponval('');
            setOrders(response?.data);
            notifyMe({ key: 'myspace', method: 'error', message: 'Coupon deleted Successfully' });
            return false;
        } else {
            setcouponvisible(false);
            setcouponval('');
            notifyMe({ key: 'myspace', method: 'error', message: response?.responseMessage });
            return false;
        }
        } catch (err) {
        setcouponvisible(false);
        notifyMe({ key: 'myspace', method: 'error', message: 'There is some error in reading details' });
        return false;
        }
    }

    return (
    <>
    <Header page={'common'}   menuSections={menu}/>
        <CartNavigation step={'step1'}/>
            <div className="container main-container cart-step mt-40 step-1">
                <div className="lft-cont">
                    <h3 className="A-la-venta-esta-sema">1. Mi cesta</h3>
                    <div className="line4"></div>
                    <Step1
                        orders_data={orders}
                        updatecartquantity={updatecartquantity}
                        removeProduct={removeProduct}
                        loader={loader}
                        savelaterproduct={savelaterproduct}
                        showData = 'availableproduct'
                        laterProducts = ''
                        addprodtocart={addprodtocart}
                        checkifproductsplitable={checkifproductsplitable}
                        isSplittable = {isSplittable}
                    />
                    <Step1
                        orders_data={orders}
                        updatecartquantity={updatecartquantity}
                        removeProduct={removeProduct}
                        loader={loader}
                        savelaterproduct={savelaterproduct}
                        showData = 'bookingproduct'
                        laterProducts = ''
                        addprodtocart={addprodtocart}
                        checkifproductsplitable={checkifproductsplitable}
                        isSplittable = {isSplittable}

                    />
                    <div className="table-right">
                    <div className="buttn tohide" onClick={() => redirectToCartStep()}>
                        <span >Confirma tu pedido</span>
                    </div>

                    </div>
                    <Step1
                        orders_data={orders}
                        updatecartquantity={updatecartquantity}
                        removeProduct={removeProduct}
                        loader={loader}
                        savelaterproduct={savelaterproduct}
                        showData = 'laterproduct'
                        laterProducts = {productadded}
                        addprodtocart={addprodtocart}
                        checkifproductsplitable={checkifproductsplitable}
                        isSplittable = {isSplittable}
                    />
                    <div className="table-right tohide">
                      <Link href="/ayuda" passhref={true}><a><u>¿Tienes dudas?</u></a></Link>
                    </div>
                </div>
                <div className="rht-cont">
                    <h3 className="A-la-venta-esta-sema">Resumen</h3>
                    <div className="line4"></div>
                    <div className="Rectangle color-div mt-20">
                        <p>{orders?.order?.totalAvailables?.orderTotal > 12.00 ? 'El envío de este pedido es gratis' : 'El importe mínimo para el envío del pedido es de 12€.'}</p>
                    </div>
                    <div className="Rectangle-2 color-div hide">
                        <p>Coloca el código NINJA y obtén <b>10% de descuento</b> en tu compra</p>
                    </div>
                    <div className="Rectangle-3 color-div">
                        <h2>Total disponibles</h2>
                        <h3>{orders?.order?.totalAvailables?.orderTotal}€</h3>
                    </div>
                    {
                      orders && orders?.order?.totalBookings?.orderTotal != ""
                      ?
                      <>
                        <div className="Rectangle-3 color-div">
                            <h2>Total reservados</h2>
                            <h3>{orders?.order?.totalBookings?.orderTotal}€</h3>
                        </div>
                      </>
                      :
                      ""
                    }
                    {
                      couponvalid == false
                      ?
                      <div className="coupon-error">
                        <p>Tu código promocional no es válido</p>
                      </div>
                      :""
                    }

                    <div className="Rectangle-4 color-div">
                      <p>Subtotal</p>
                    <div className="mar-wrap-lft input-group mb-3">
                    {!couponvisible ?   <input type="text" placeholder="Agrega tu cupón" value={couponval} className={couponvalid == false ? "form-control-2 coupon-error-input" :"form-control-2"} onChange={(event) => setcouponval(event.target.value)}/>
                        : <span className="coupon-text">{couponval}</span>
                    }
                      <div className="input-group-append">
                        {!couponvisible ?
                           <button className="btn5" onClick={() => addCoupon()}>Aplicar</button>
                        :
                          <button className="btn5" onClick={() => removeCoupon()}>Remove</button>
                        }
                      </div>
                    </div>
                    <div className="mar-wrap-rht">
                    <Link href="#" passHref={true}><img src="assets/images/info.png"  alt=""/></Link>
                    </div>
                    <div className="coupon">
                      <div className="blue-triangle"></div>
                        <div className="coupon-desc">
                        <p>
                        Si tienes un código de descuento colócalo aquí
                        </p>
                        </div>
                    </div>
                    {
                      couponvalid == true
                      ?
                        <div className="Rectangle-3 color-div">
                            <h2>Descuento Cupon</h2>
                            <h3>-{orders?.order?.couponDiscountAmount}€</h3>
                        </div>
                      :
                      ""
                    }
                    </div>
                    <div className="Rectangle-3 color-div">
                        <h2>Total pedido</h2>
                        <h3>{orders?.order?.grandTotal}€</h3>
                    </div>
                    <div className="buttn tohide"  onClick={() => redirectToCartStep()}>
                        <span>Confirma tu pedido</span>
                    </div>
                </div>
                <div className="clearfix"></div>
                <div className={screensresolution == "tab"? "step-below-pink" : "step-below-pink hide"}>
                  <div className="pink-pattern-layer">
                  <img src="/assets/images/lineas.png" alt=""/>
                  </div>
                  <div className="pink-div-layer">
                    <p>Tu código promocional no es válido</p>
                  </div>
                  </div>
                  <div className="step-below-blue hide">
                  <div className="blue-div-layer">
                    <div className="disponibles">
                      <p className="float-left">2 productos disponibles</p>
                      <p className="float-right">Subtotal <b>{orders?.order?.totalAvailables?.orderTotal}€</b></p>
                      </div>
                        <div className="clearfix"></div>
                        {
                          orders?.order?.totalBookings?.orderTotal != ""
                          ?
                          <>
                            <div className="reservados">
                              <p className="float-left">2 productos reservados</p>
                              <p className="float-right">Subtotal <b>{orders?.order?.totalBookings?.orderTotal}€</b></p>
                            </div>
                            <div className="clearfix"></div>
                          </>
                          :
                          ""
                        }
                    <div className="Total">
                      <p className="float-right">Total <b>{orders?.order?.grandTotal}€s</b></p>
                    </div>
                      <div className="clearfix"></div>
                      <div className="buttn" onClick={() => redirectToCartStep()}>
                        <span >Confirma tu pedido</span>
                      </div>
                  </div>
                </div>
                <div className="buttn belowbtn" onClick={() => redirectToCartStep()}>
                    <span >Confirma tu pedido</span>
                </div>
                <div className="dudas">
                  <Link href="/ayuda" passHref={true}><u>¿Tienes dudas?</u></Link>
                </div>
            </div>

            <div className="container line-container">
              <div className="line6"></div>
            </div>
            <SubscribeNewsLetter webTexts={webTexts}/>
        <HomeFooter />
    </>
  );
};

async function loadData(context){                   
    return {};
}

export async function getStaticProps(context) {    
    return InitializePage(context,loadData, true)
}

export default withAuthHOC(Checkout);
